export default __webpack_public_path__ + "static/media/Weather_07.737abdf7.png";